import React, {Component} from "react";
import {withStyles, Box, Button} from "@material-ui/core";
import {styles} from "./styles";
import {inject, observer} from "mobx-react";

import List from "../../components/List";
import {userGroupHeaders, userGroupListHeaders} from "../../constants/settings";
import {ModalDialog} from "../../components/Modal";

@inject("usersManager")
@observer
class UserGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      data: {},
    }
  }

  componentDidMount() {
    const {usersManager} = this.props;
    usersManager.listByGroup();
  }

  closeModal = () => {
    this.setState({openModal: false, data: {}})
  }

  getModalTitle = () => {
    const {data} = this.state;
    if (data.role === "admin") {
      return "Admin Member List";
    } else if (data.role === "client") {
      return "Team Member List";
    } else if (data.role === "viewonly") {
      return "View Only Member List";
    } else {
      return "";
    }
  }

  renderRole = (row, field) => {
    const scopes = field && row[field] ? row[field].split(/\s/g) : [];
    if (row.role === "admin" || (scopes.includes("client-admin"))) {
      return "Admin";
    } else if (row.role === "client" || (scopes.includes("client"))) {
      return "Team Member";
    } else if (row.role === "viewonly" || (scopes.includes("client-read-only"))) {
      return "View Only";
    } else {
      return "Other";
    }
  }

  renderType = (row) => {
    if (row.role === "admin") {
      return "Can update data & edit users";
    } else if (row.role === "client") {
      return "Can update data";
    } else if (row.role === "viewonly") {
      return "View Only";
    } else {
      return "Other";
    }
  }

  renderAccess = (row) => {
    if (row.role === "admin" ) {
      return "All tabs";
    } else if (row.role === "client") {
      return "All tabs";
    } else if (row.role === "viewonly") {
      return "Limited";
    } else {
      return "Limited";
    }
  }

  renderActions = (row) => {
    const {classes} = this.props;
    return (
      <Box align="center">
        <Button onClick={() => this.setState({openModal: true, data: row})} className={classes.viewListButton}>
          View list
        </Button>
      </Box>
    )
  }

  render() {
    const {openModal, data} = this.state;
    const {usersManager} = this.props;
    const {groups} = usersManager;
    const rows = ["admin", "client", "viewonly"].map(role => ({
      role,
      count: !groups[role] ? 0 : groups[role].length,
      users: groups[role],
    }));
    const renderer = {
      role: (row) => this.renderRole(row),
      role_type: (row) => this.renderType(row),
      access: (row) => this.renderAccess(row),
      actions: (row) => this.renderActions(row),
    };

    const detailRenderer = {
      _scopes: (row, field) => this.renderRole(row, field),
    };

    return (
      <Box>
        <List store={{}} rows={rows} schema={userGroupHeaders} renderer={renderer} disablePagination />

        <ModalDialog open={openModal} title={this.getModalTitle()} onClose={this.closeModal} onOk={this.closeModal} noActions>
          <Box pb={2}>
            <List store={{}} rows={data.users} schema={userGroupListHeaders} renderer={detailRenderer} disablePagination />
          </Box>
        </ModalDialog>
      </Box>
    );
  }
}

export default withStyles(styles)(UserGroups);